<template>
  <section v-if="!isReady || isGetCollectionRequestPending" class="pipelines">
    <p-loading />
  </section>

  <section v-else class="pipelines">
    <header>
      <h1>Pipelines</h1>
      <section class="action-wrapper">
        <router-link v-if="$hasPermission('portfolio')" to="/pipelines/new">+ new</router-link>
      </section>
    </header>
    <section>
      <p-list
        name="pipelines"
        :data="collection"
        :total="total"
        :metadata="{
          title: { label: 'Title', width: 'minmax(0, 3fr)' },
          status: { label: 'Status', width: 'minmax(0, 2fr)' },
          tags: { label: 'Tags', width: 'minmax(0, 2fr)' },
          autoSchedule: { label: 'Auto schedule', width: 'minmax(0, 2fr)' },
          priority: { label: 'Priority', width: 'minmax(0, 1fr)' },
          completed: { label: 'Completed', width: 'minmax(0, 1fr)' },
          partiallyCompleted: { label: 'Partial', width: 'minmax(0, 1fr)' },
          failed: { label: 'Failed', width: 'minmax(0, 1fr)' },
          pending: { label: 'Pending', width: 'minmax(0, 1fr)' }
        }"
      >
        <template #title="{ item }">
          <router-link :to="`/pipelines/${item._id}`">{{ item.title }}</router-link>
        </template>
        <template #status="{ item }">
          <span class="status-label" :class="item.isActive ? 'active' : 'paused'">{{ item.isActive ? 'Running' : 'Paused' }}</span>
        </template>
        <template #autoSchedule="{ item }">
          {{ item.autoSchedule === false ? 'No' : 'Yes' }}
        </template>

        <template #__actions="{ item }">
          <p-button variant="text" title="View run history" @click="$router.push(`/pipelines/${item._id}/history`)">
            <MdIcon name="history" size="md" />
          </p-button>
        </template>
      </p-list>
    </section>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Button from './../common/Button';
import Loading from './../common/Loading';
import List from './../common/List';
import MdIcon from './../common/MdIcon';

export default {
  name: 'ListPipeline',
  components: {
    'p-list': List,
    'p-loading': Loading,
    'p-button': Button,
    MdIcon
  },
  data() {
    return {
      isReady: false
    };
  },
  computed: {
    ...mapState({
      collection: s => s.pipelines.collection,
      total: s => s.pipelines.total,
      isGetCollectionRequestPending: s => s.pipelines.isGetCollectionRequestPending
    })
  },
  async created() {
    try {
      await this.$store.dispatch('pipelines/getCollection');
    } catch (e) {
      this.$toast.error({
        title: 'Failed to load pipelines',
        message: 'Please, try again later or contact our development team.'
      });
    } finally {
      this.isReady = true;
    }
  }
};
</script>

<style scoped lang="scss">
.pipelines {
  display: grid;
  padding: 0 0.5rem 0 1rem;
  grid-template-columns: 1fr;
  grid-template-rows: max-content minmax(0, 1fr);
  grid-gap: 0.5rem;
  width: 100%;
  height: 100%;

  > header {
    padding: 0.5rem 0.5rem 0;
    display: flex;
    justify-content: space-between;

    box-sizing: border-box;
    h1 {
      color: var(--theme-on-surface);
      font-size: 1.5rem;
      font-weight: 700;
      margin-right: 0.25rem;
    }

    .action-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }

  .status-label {
    display: inline-flex;
    line-height: 1;
    height: 1rem;
    justify-content: center;
    align-items: center;
    border-radius: 10%;
    padding: 0.2rem 0.4rem;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;

    &.active {
      color: var(--theme-on-success);
      background-color: var(--theme-success);
    }

    &.paused {
      color: var(--theme-on-background-accent);
      background-color: var(--theme-highlight);
    }
  }
}
</style>
